// 提示框
export const showToast = (title, options = {}) => {
	return new Promise((resolve,reject)=>{
		//默认配置
		let config = {
			icon: 'none',
			image: '',
			mask: true,
			duration: 1500
		}
		//对象合并 新旧配置合并
		Object.assign(config,options);
		
		uni.showToast({
			title: String(title),
			...config
		}).then(()=>{
			setTimeout(resolve,config.duration)
		})
	})
}

//防抖
export function debounce(func, timeout = 300){
	let timer;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => { func.apply(this, args); }, timeout);
	};
}

//节流
export function throttle(fn, mustDelay = 300){
    let timer,
        start = 0;
    return function (...args){
        let now = new Date().getTime();
        if(now > start + mustDelay){
            fn.apply(this,args)
            start = now;
        }
    }
}

//路由
export const router = debounce((options = {}) => {
	if(typeof options === 'string'){
		uni.navigateTo({
			url: options,
			fail: err => {
				console.log(err)
			}
		})
	}else{
		const { url, delta } = options;
		switch(options.type){
			case 'navigateTo':
				uni.navigateTo({
					url
				})
				break;
			case 'redirectTo':
				uni.redirectTo({
					url
				})
				break;
			case 'reLaunch':
				uni.reLaunch({
					url
				})
				break;
			case 'switchTab':
				uni.switchTab({
					url
				})
				break;
			case 'navigateBack':
				uni.navigateBack({
					delta
				})
				break;
			default: ;
		}
	}
}, 300);

export function getUrlParams(variable, query) {
	const vars = query.split("&");
	for (let i = 0; i < vars.length; i++) {
		const pair = vars[i].split("=");
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return false;
}

export function toFixedRound(value, decimal = 2) {
    if (isNaN(value)) {
        return '0.00';
    }
    const multiplier = Math.pow(10, decimal);
    return (Math.round(Number(value) * multiplier) / multiplier).toFixed(decimal);
}

// 获取后端多语言key
const backendLanguageKey = {
	'zh-Hans': 'zh_CN',
	'zh-Hant': 'zh_TW',
	'en': 'en_US',
}
export function getBackendLanguageKey(key) {
	return backendLanguageKey[key] || key;
}

// 解析多语言 JSON 串：{"zh_CN":"...","en_US":"..."} → 按当前语言取文案，逐级兜底
export function parseLangText(text) {
	if (text == null) return '';
	let obj;
	try {
		obj = JSON.parse(text);
	} catch (_) {
		return String(text); // 非 JSON，按纯文本返回
	}
	if (typeof obj !== 'object' || obj === null) return String(text);
	const langKey = getBackendLanguageKey(uni.getStorageSync('language') || uni.getLocale());
	return obj[langKey] || obj.zh_CN || Object.values(obj)[0] || '';
}

// 中间打码：保留前 head 位与后 tail 位，中间用 ... 代替
export function maskMiddle(str, head = 4, tail = 4) {
	if (!str) return '';
	const s = String(str);
	if (s.length <= head + tail) return s;
	return `${s.slice(0, head)}...${s.slice(-tail)}`;
}

